export default __webpack_public_path__ + "static/media/jazy.fbe36371.png";